import { TCurrentEnvValues } from 'helpers'

export const getCurrentEnv = () =>
  (document.querySelector('meta[name="current-env"]') as HTMLMetaElement)
    .content as TCurrentEnvValues
